import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody, Button } from 'sfy-react';

import './modal.scss'
import ButtonContainer from '../buttonContainer';
function RejectModal(props) {
 const { showModal, closeModal, no_btn_click, yes_btn_click } = props;

 return (
  <Modal showModal={showModal} closeModal={closeModal} className='pwa-req-success-modal' backdropClassName='brand-pp-backdrop'>
   <ModalHeader>
    <Row >
     <Col xs={12} className='reject-modal-header'>
      <span>Reject Exchange
      </span>
     </Col>
    </Row>
   </ModalHeader>
   <ModalBody>
    <Row>
     <Col xs={12} className='reject-modal-desc'>
      <span>Are you sure you want to reject the device exchange?
      </span>
     </Col>
    </Row>
    <div style={{ width: '100%', marginTop: '30px' }}>
     <Container fluid className="p-20 m-0 g-0" style={{ backgroundColor: '#FFFFFF', height: "100%" }}>
      <Row className="flex-column-reverse flex-md-row">
       <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button type='button' text={"No"} classes='pwa-secondary-continue-btn'
         handleOnClick={no_btn_click} >
        </Button>
       </Col>
       <Col xs={12} md={6} >
        <Button type='button' text={"Yes"} classes='pwa-continue-btn'
         handleOnClick={yes_btn_click} >
        </Button>
       </Col>
      </Row>
     </Container>
     {/* <div style={{ bottom: '20px' }}>
      <Button type='button' text={'Yes'} classes='pwa-continue-btn'
       handleOnClick={yes_btn_click} >
      </Button>
     </div>
     <div style={{ bottom: '20px', marginTop: "10px", marginBottom: '20px' }}>
      <Button type='button' text={"No"} classes='pwa-secondary-continue-btn'
       handleOnClick={no_btn_click} >
      </Button>
     </div> */}
    </div>

   </ModalBody>

  </Modal>
 );
}
export default RejectModal
